import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';

function Datewise() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });
    const printRef = useRef();
    const [loading, setloading] = useState(false);
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const [fromDate, setfromDate] = useState("");
    const [toDate, settoDate] = useState("");
    const [username, setusername] = useState("");
    const [bookingData, setbookingData] = useState([]);

    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        setloadincount(false)
                    }

                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    const getReport = async () => {
        if (!fromDate || !toDate) {
            Toast.fire({ icon: "error", title: 'Please select From Date & To Date' });
            return;
        }

        setloading(true);
        setbookingData([]);

        const startOfDay = new Date(fromDate);
        startOfDay.setHours(0, 0, 0, 0);
        const endOfDay = new Date(toDate);
        endOfDay.setDate(endOfDay.getDate() + 1); // Make range exclusive

        // === 1. FETCH PAYMENT HISTORY ===
        const paymentQuery = query(
            collection(db, 'payhistory'),
            where('status', '==', 'Working'),
            where('createdAt', '>=', Timestamp.fromDate(startOfDay)),
            where('createdAt', '<', Timestamp.fromDate(endOfDay))
        );

        const paymentSnapshot = await getDocs(paymentQuery);
        const paymentHistoryData = await Promise.all(paymentSnapshot.docs.map(async (doc1) => {
            const data = doc1.data();
            const [pm1Snap, pm2Snap] = await Promise.all([
                getDoc(doc(db, 'paymentmodes', data.paymode1)),
                getDoc(doc(db, 'paymentmodes', data.paymode2))
            ]);
            return {
                id: doc1.id,
                data,
                paymode1: pm1Snap.exists() ? pm1Snap.data().paymode : '',
                paymode2: pm2Snap.exists() ? pm2Snap.data().paymode : '',
                amount1: data.amount1 || 0,
                amount2: data.amount2 || 0,
                createdat: moment(data.createdAt.toDate()).format('DD-MM-YYYY HH:mm:ss')
            };
        }));

        // === 2. FETCH CHECKIN DETAILS (STATUS: Booked + Checkout) BY DATE RANGE ===
        const checkinQuery = query(
            collection(db, 'checkindetails'),
            where('status', 'in', ['Booked', 'Checkout']),
            where('checkindate', '>=', moment(fromDate).format('YYYY-MM-DD')),
            where('checkindate', '<=', moment(toDate).format('YYYY-MM-DD'))
        );

        const checkinSnapshot = await getDocs(checkinQuery);
        const checkinDetailsData = checkinSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        const uniqueCheckins = Array.from(new Map(checkinDetailsData.map(item => [item.bookingid, item])).values());
        const bookingIds = uniqueCheckins.map(item => item.bookingid);

        if (bookingIds.length === 0) {
            Toast.fire({ icon: "info", title: 'No bookings found in this date range.' });
            setloading(false);
            return;
        }

        // === 3. FETCH BOOKINGS IN BATCHES OF 30 ===
        const fetchBookingsInChunks = async (ids) => {
            const chunks = [];
            while (ids.length) chunks.push(ids.splice(0, 30));

            let results = {};
            for (let chunk of chunks) {
                const bookingsQuery = query(
                    collection(db, 'bookings'),
                    where('__name__', 'in', chunk)
                );
                const snapshot = await getDocs(bookingsQuery);
                snapshot.docs.forEach(doc => {
                    results[doc.id] = { id: doc.id, ...doc.data() };
                });
            }
            return results;
        };

        const bookingsDataMap = await fetchBookingsInChunks([...bookingIds]);

        // === 4. GROUP PAYMENT HISTORY BY BOOKING ID ===
        const paymentHistoryMap = {};
        for (let pay of paymentHistoryData) {
            const bid = pay.data.bookingid;
            if (!paymentHistoryMap[bid]) paymentHistoryMap[bid] = [];
            paymentHistoryMap[bid].push(pay);
        }

        // === 5. COMBINE FINAL DATA ===
        const finalData = await Promise.all(uniqueCheckins.map(async (checkin) => {
            const booking = bookingsDataMap[checkin.bookingid];
            if (!booking) return null;

            let username = "Unknown";
            if (checkin.uid) {
                const userSnap = await getDoc(doc(db, "users", checkin.uid));
                if (userSnap.exists()) username = userSnap.data().username || "Unnamed";
            }

            // Fetch customer info
            let customerName = booking.customers.custname
            let mobileNo = booking.customers.mobile

            const roomamount = parseFloat(booking.rooamount || 0);
            const servicePerDay = parseFloat(booking.serviceamount || 0) / (parseFloat(booking.noofdays) || 1);
            const date1 = moment(booking.checkindate);
            const date2 = moment(checkin.checkindate);
            const dayDiff = Math.max(1, date2.diff(date1, 'days'));

            const foodOrdersQuery = query(
                collection(db, 'orders'),
                where('status', '==', 'Bill Pending'),
                where('bookingId', '==', checkin.bookingid),
                where('orderdate', '==', checkin.checkindate)
            );
            const foodSnapshot = await getDocs(foodOrdersQuery);
            let foodTotal = 0;
            foodSnapshot.forEach(doc => foodTotal += doc.data().totalamount || 0);

            const payments = paymentHistoryMap[checkin.bookingid] || [];
            const paid = payments.reduce((sum, p) => sum + p.amount1 + p.amount2, 0);

            const dayAmount = roomamount + servicePerDay + foodTotal;
            const allTotal = dayAmount * dayDiff;
            const pending = allTotal - paid;

            return {
                ...checkin,
                booking,
                username,
                roomamount: roomamount.toFixed(0),
                serviceamount: servicePerDay.toFixed(0),
                foodamount: foodTotal.toFixed(0),
                totalamount: dayAmount.toFixed(0),
                alltoal: allTotal.toFixed(0),
                paidamount: paid.toFixed(0),
                pending: pending.toFixed(0),
                todayDays: dayDiff,
                paymentHistory: payments,
                customerName:customerName,
                mobileNo:mobileNo,
            };
        }));

        setbookingData(finalData.filter(item => item !== null));
        setloading(false);
    };



    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })

    const handleFromDate = (e) => {
        setfromDate(e.target.value)
        setloading(false)
    }
    const handleToDate = (e) => {
        settoDate(e.target.value)
        setloading(false)
    }

    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " >|| Datewise Booking Report ||</button><br /><br />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label>From Date</label>
                                                <input type='date' value={fromDate} onChange={handleFromDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-4'>
                                                <label>To Date</label>
                                                <input type='date' value={toDate} onChange={handleToDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-3'>
                                                <br />
                                                <button className='btn btn-info' onClick={getReport}>Get Report</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card card-primary card-outline" ref={printRef}>
                                    <div className="card-body">
                                        <div className="row invoice-info">
                                            <div className="col-sm-12 invoice-col text-center">
                                                <address>
                                                    <h4>Dasara Executive</h4>
                                                    Chatrapati Shivaji Maharaj Chouk, Tuljapur, Dist - Dharashiv, MH - 413601<br />
                                                    Phone: +91 9975294940 |
                                                    Email:  dasaraexecutive@gmail.com<br />
                                                    Website:  www.dasaraexecutive.com
                                                </address>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <table className='customers '>
                                                <tr>
                                                    <th style={{ textAlign: "center" }}>From Date : {moment(fromDate).format('DD/MM/YYYY')}  </th>
                                                    <th style={{ textAlign: "center" }}><h5>DATEWISE BOOKING REPORT </h5></th>
                                                    <th style={{ textAlign: "center" }}>To Date : {moment(toDate).format('DD/MM/YYYY')}</th>
                                                </tr>
                                            </table>
                                            <table className="table table-bordered mt-4">
                                                <thead>
                                                    <tr>
                                                        <th>Sr No</th>
                                                        <th>Date</th>
                                                        <th>Customer</th>
                                                        <th>Username</th>
                                                        <th>Room Amount</th>
                                                        <th>Service</th>
                                                        <th>Food</th>
                                                        <th>Total</th>
                                                        <th>All Total</th>
                                                        <th>Paid</th>
                                                        <th>Pending</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Object.entries(
                                                        bookingData.reduce((acc, row) => {
                                                            if (!acc[row.checkindate]) acc[row.checkindate] = [];
                                                            acc[row.checkindate].push(row);
                                                            return acc;
                                                        }, {})
                                                    ).map(([date, rows]) => {
                                                        let dateRoomTotal = 0;
                                                        let dateServiceTotal = 0;
                                                        let dateFoodTotal = 0;
                                                        let dateTotal = 0;
                                                        let dateAllTotal = 0;
                                                        let datePaid = 0;
                                                        let datePending = 0;

                                                        return (
                                                            <React.Fragment key={date}>
                                                                {rows.map((row, index) => {
                                                                    dateRoomTotal += parseFloat(row.roomamount);
                                                                    dateServiceTotal += parseFloat(row.serviceamount);
                                                                    dateFoodTotal += parseFloat(row.foodamount);
                                                                    dateTotal += parseFloat(row.totalamount);
                                                                    dateAllTotal += parseFloat(row.alltoal);
                                                                    datePaid += parseFloat(row.paidamount);
                                                                    datePending += parseFloat(row.pending);

                                                                    return (
                                                                        <tr key={row.id}>
                                                                            <td>{index+1}</td>
                                                                            <td>{index === 0 ? date : ""}</td>
                                                                            <td>{row.customerName}</td>
                                                                            <td>{row.username}</td>
                                                                            <td>{row.roomamount}</td>
                                                                            <td>{row.serviceamount}</td>
                                                                            <td>{row.foodamount}</td>
                                                                            <td>{row.totalamount}</td>
                                                                            <td>{row.alltoal}</td>
                                                                            <td>{row.paidamount}</td>
                                                                            <td>{row.pending}</td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                                <tr style={{ backgroundColor: '#f2f2f2', fontWeight: 'bold' }}>
                                                                    <td colSpan="4">Total for {date}</td>
                                                                    <td>{dateRoomTotal.toFixed(0)}</td>
                                                                    <td>{dateServiceTotal.toFixed(0)}</td>
                                                                    <td>{dateFoodTotal.toFixed(0)}</td>
                                                                    <td>{dateTotal.toFixed(0)}</td>
                                                                    <td>{dateAllTotal.toFixed(0)}</td>
                                                                    <td>{datePaid.toFixed(0)}</td>
                                                                    <td>{datePending.toFixed(0)}</td>
                                                                </tr>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </tbody>

                                                {/* Grand Total Row */}
                                                <tfoot>
                                                    <tr style={{ backgroundColor: '#d0e7ff', fontWeight: 'bold' }}>
                                                        <td colSpan="4">Grand Total</td>
                                                        <td>
                                                            {bookingData.reduce((sum, r) => sum + parseFloat(r.roomamount), 0).toFixed(0)}
                                                        </td>
                                                        <td>
                                                            {bookingData.reduce((sum, r) => sum + parseFloat(r.serviceamount), 0).toFixed(0)}
                                                        </td>
                                                        <td>
                                                            {bookingData.reduce((sum, r) => sum + parseFloat(r.foodamount), 0).toFixed(0)}
                                                        </td>
                                                        <td>
                                                            {bookingData.reduce((sum, r) => sum + parseFloat(r.totalamount), 0).toFixed(0)}
                                                        </td>
                                                        <td>
                                                            {bookingData.reduce((sum, r) => sum + parseFloat(r.alltoal), 0).toFixed(0)}
                                                        </td>
                                                        <td>
                                                            {bookingData.reduce((sum, r) => sum + parseFloat(r.paidamount), 0).toFixed(0)}
                                                        </td>
                                                        <td>
                                                            {bookingData.reduce((sum, r) => sum + parseFloat(r.pending), 0).toFixed(0)}
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>



                                        </div>
                                    </div>

                                </div>
                                <center>
                                    <button className='btn btn-success' onClick={handlePrint}>Print Report</button>
                                </center>
                            </div>
                        </div>
                    </div>
                </section >

            </div>

        </div >

    )
}

export default Datewise
